/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FieldOrigin;
(function (FieldOrigin) {
    FieldOrigin["Request"] = "REQUEST";
    FieldOrigin["Response"] = "RESPONSE";
})(FieldOrigin || (FieldOrigin = {}));
export function FieldOriginFromJSON(json) {
    return FieldOriginFromJSONTyped(json, false);
}
export function FieldOriginFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FieldOriginToJSON(value) {
    return value;
}
